<template>
    <div class="c-nongye-left">
        <top-tabs :tabsObj="tabsObj"></top-tabs>
        <div class="c-nongye-left__content">
            <div class="c-nongye-left__search">
                <el-input v-model="keyword" placeholder="请输入搜索地块名称" clearable size="small" prefix-icon="el-icon-search" @input="handleSearch"></el-input>
            </div>
            <YScroll class="c-nongye-left__body">
                <el-tree
                    ref="treeRef"
                    class="c-nongye-left__tree"
                    node-key="id"
                    :data="treeData"
                    :props="treeProps"
                    highlight-current
                    default-expand-all
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                    @node-expand="handleNodeExpand"
                    @node-collapse="handleNodeCollapse"
                    @check="handleCheck"
                >
                    <template #default="{ data }">
                        <div v-if="isPlot(data)" class="leaf-node" :class="{ active: activeId === data.id }">
                            <div class="leaf-row leaf-title">
                                <span class="leaf-name">{{ data.plotName }}</span>
                                <span class="leaf-area">{{ data.area }} 亩</span>
                            </div>
                            <el-tooltip class="leaf-row leaf-address" effect="dark" :content="`地址：${data.address || '占位符占位符'}`" placement="top" :show-after="200" :disabled="!(data.address && data.address.length > 20)">
                                <div class="leaf-address-text">地址：{{ data.address || '占位符占位符' }}</div>
                            </el-tooltip>
                        </div>
                        <div v-else class="branch-node" :class="{ active: activeBranchId === data.id }" @click.stop="handleBranchClick(data)">
                            <span class="branch-label">
                                {{ data.name }}<span class="branch-count" v-if="getBranchCount(data) != null"> {{ getBranchCount(data) }}</span>
                            </span>
                            <i class="el-icon-arrow-down branch-toggle"
                                :class="{ expanded: data.__expanded }"></i>
                        </div>
                    </template>
                </el-tree>
            </YScroll>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import TopTabs from '@/components/topTabs.vue';
import NongyeApi from '../api';

export default {
    name: 'LeftAside',
    components: { TopTabs, YScroll },
    props: {
        treeData: { type: Array, default: () => [] },
        activeId: { type: [String, Number], default: null },
    },
    data() {
        return {
            keyword: '',
            tabsObj: { centre: '地块列表', type: 3 },
            activeBranchId: null,
        };
    },
    computed: {
        treeProps() {
            return {
                label: 'name',
                children: 'children',
                class: (data) => (!this.isPlot(data) ? 'empty-region' : ''),
            };
        },
    },
    watch: {
        treeData: {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    if (this.$refs.treeRef) {
                        this.$refs.treeRef.filter(this.keyword);
                        this.initExpandedFlag(this.treeData);
                    }
                });
            },
        },
    },
    methods: {
        isPlot(data) {
            return data && (data.area !== undefined || data.landType !== undefined);
        },
        initExpandedFlag(nodes) {
            const walk = (list) => {
                if (!Array.isArray(list)) return;
                list.forEach((n) => {
                    if (!this.isPlot(n)) {
                        if (n.__expanded === undefined) n.__expanded = true;
                    }
                    if (n.children) walk(n.children);
                });
            };
            walk(nodes);
        },
        getBranchCount(data) {
            if (data == null) return null;
            if (data.count != null) return data.count;
            const countLeaves = (nodes) => {
                let total = 0;
                if (!Array.isArray(nodes)) return total;
                nodes.forEach((n) => {
                    if (this.isPlot(n)) {
                        total += 1;
                    } else if (n.children) {
                        total += countLeaves(n.children);
                    }
                });
                return total;
            };
            if (Array.isArray(data.children) && data.children.length > 0) {
                const total = countLeaves(data.children);
                if (total > 0) return total;
                return data.children.length;
            }
            return null;
        },
        toggleExpand(data) {
            const node = this.$refs.treeRef.getNode(data);
            if (!node) return;
            if (node.expanded) {
                node.collapse();
            } else {
                node.expand();
            }
        },
        handleBranchClick(data) {
            this.activeBranchId = data.id;
            this.toggleExpand(data);
        },
        handleNodeExpand(data) {
            if (!this.isPlot(data)) {
                data.__expanded = true;
            }
        },
        handleNodeCollapse(data) {
            if (!this.isPlot(data)) {
                data.__expanded = false;
            }
        },
        filterNode(value, data) {
            if (!this.isPlot(data)) return true;
            const kw = (this.keyword || '').trim();
            if (!kw) return true;
            const label = `${data.plotName || data.name || ''} ${data.plotCode || ''}`;
            return String(label).includes(kw);
        },
        doFilter() {
            this.$refs.treeRef && this.$refs.treeRef.filter(this.keyword);
        },
        handleSearch() {
            this.doFilter();
            this.$emit('search', { keyword: this.keyword, startDate: '', endDate: '' });
        },
        handleNodeClick(data) {
            if (this.isPlot(data)) {
                this.$emit('node-click', data);
                this.$emit('select', data);
            }
        },
        handleCheck(data, checkedInfo) {
            this.$emit('check', data, checkedInfo);
        },
        async handleDelete(data) {
            try {
                await this.$confirm(`确认删除地块「${data.plotName}」？`, '提示', { type: 'warning' });
                await NongyeApi.delAgriPlot(data.id);
                this.$message.success('删除成功');
                this.$emit('delete', data);
            } catch (e) {
                if (e !== 'cancel') this.$message.error('删除失败');
            }
        },
        handleEdit(data) {
            this.$emit('edit', data);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-nongye-left {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: #fff;

    &__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 8px 12px;
        min-height: 0;
    }

    &__search {
        margin-bottom: 10px;
        padding-top: 4px;

        ::v-deep .el-input__inner {
            background: rgba(10, 26, 58, 0.6);
            border-color: #1a47a4;
            color: #fff;
        }

        ::v-deep .el-input__inner::placeholder {
            color: #9bb0d9;
        }
    }

    &__body {
        flex: 1;
        min-height: 0;
    }

    &__tree {
        background: transparent;
        color: #fff;
        padding: 0;

        ::v-deep .el-tree-node {
            padding-left: 0 !important;
        }

        ::v-deep .el-tree-node__children {
            padding-left: 0 !important;
        }

        ::v-deep .el-tree-node__content {
            height: auto;
            align-items: flex-start;
            padding: 0 !important;
            margin: 2px 0;
            background: transparent !important;
            border: none !important;
        }

        ::v-deep .el-tree-node.is-current > .el-tree-node__content {
            background: transparent !important;
        }

        ::v-deep .el-tree-node__expand-icon {
            display: none !important;
        }

        ::v-deep .empty-region .el-checkbox {
            display: none;
        }

        ::v-deep .leaf-node {
            width: 100%;
            padding: 5px 8px 5px 8px;
            background: linear-gradient(90deg, rgba(10, 167, 255, 0.22) 0%, rgba(10, 167, 255, 0.04) 50%, rgba(10, 167, 255, 0) 100%);
            border: 1px solid rgba(26, 71, 164, 0.7);
            border-left: 3px solid #0aa7ff;
            border-radius: 2px;
            box-sizing: border-box;
            margin: 0;
            cursor: pointer;
            transition: all 0.2s;

            &.active {
                background: rgba(26, 71, 164, 0.55);
                border-color: #5bf0fc;
                border-left-color: #5bf0fc;
            }

            &:hover {
                background: rgba(26, 71, 164, 0.45);
            }

            .leaf-row {
                line-height: 18px;
            }

            .leaf-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 13px;
                color: #fff;
                width: 100%;

                .leaf-name {
                    font-weight: 500;
                    flex: 1;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding-right: 8px;
                }

                .leaf-area {
                    // color: #9bb0d9;
                    flex-shrink: 0;
                    white-space: nowrap;
                }
            }

            .leaf-address {
                font-size: 12px;
                // color: #8fa4cd;
                margin-top: 3px;
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                min-width: 0;
            }

            .leaf-address-text {
                display: block !important;
                width: 100% !important;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
            }
        }

        ::v-deep .branch-node {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            min-height: 32px;
            font-size: 14px;
            color: #5bf0fc;
            line-height: 32px;
            padding: 0 10px 0 12px;
            margin: 2px 0;
            cursor: pointer;
            background: linear-gradient(90deg, rgba(10, 26, 58, 0.85) 0%, rgba(10, 26, 58, 0.6) 100%);
            border: 1px solid rgba(26, 71, 164, 0.9);
            border-radius: 2px;
            box-sizing: border-box;
            transition: all 0.2s;

            &:hover {
                background: linear-gradient(90deg, rgba(26, 71, 164, 0.85) 0%, rgba(26, 71, 164, 0.55) 100%);
            }

            &.active {
                border-color: #5bf0fc;
                box-shadow: 0 0 0 1px rgba(255, 49, 49, 0.35) inset;
            }

            .branch-label {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 500;
            }

            .branch-count {
                color: #ffffff;
                font-size: 13px;
                font-weight: 600;
            }

            .branch-toggle {
                font-size: 14px;
                color: #5bf0fc;
                transition: transform 0.2s;
                flex-shrink: 0;
                margin-left: 8px;

                &.expanded {
                    transform: rotate(180deg);
                }
            }
        }
    }
}
</style>

<style lang="scss">
.c-nongye-left .el-tree-node__content {
    padding-left: 0 !important;
}

.c-nongye-left .el-tree-node__children {
    padding-left: 0 !important;
}
</style>
